"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    demand: {
        en: "Demand",
        es: "Demanda",
    },
    demandField: {
        en: "Load demand",
        es: "Demanda de carga",
    },
    demandDescription: {
        en: "You can interpret load demand as any measure unit or presentation depending on your needs, example: kilograms, pounds, boxes, barrels...",
        es: "Puede interpretar la demanda de carga con cualquier unidad de medida o presentación según la necesidad, ejemplo: kilogramos, libras, cajas, barriles..",
    },
    routes: {
        en: "Routes",
        es: "Rutas",
    },
    fleet: {
        en: "Fleet",
        es: "Flota",
    },
    stops: {
        en: "Stops",
        es: "Visitas",
    },
    results: {
        en: "Results",
        es: "Resultados",
    },
    back: {
        en: "Back",
        es: "Atrás",
    },
    previous: {
        en: "Previous",
        es: "Anterior",
    },
    new: {
        en: "New",
        es: "Nuevo",
    },
    calculate: {
        en: "Calculate",
        es: "Calcular",
    },
    calculateComplete: {
        en: "Calculation completed",
        es: "Calculo completado",
    },
    missingFields: {
        en: "Check the form before we continue.",
        es: "Revise el formulario antes de continuar.",
    },
    depot: {
        en: "Start location",
        es: "Punto de partida",
    },
    sameAsDepot: {
        en: "Same as start",
        es: "Igual al punto de partida",
    },
    tripDuration: {
        en: "Trip duration",
        es: "Tiempo de viaje",
    },
    endsAtSpecificLocation: {
        en: "Ends At Specific Location",
        es: "Termina en un lugar especifico",
    },
    endPoi: {
        en: "Ends location",
        es: "Punto final",
    },
    capacity: {
        en: "Capacity",
        es: "Capacidad",
    },
    devicesUser: {
        en: "Units {devices} of {total}",
        es: "Unidades {devices} de {total}",
    },
    pointsVisited: {
        en: "Points of interest {pois} of {total}",
        es: "Puntos de interés {pois} de {total}",
    },
    routePlanner: {
        en: "Route Planner",
        es: "Planeador de rutas",
    },
    dropsExist: {
        en: "There is lack of vehicle capacity to complete route.",
        es: "No hay capacidad vehicular para completar la ruta.",
    },
    capacityRequired: {
        en: "The capacity is required.",
        es: "La capacidad es requerida.",
    },
    capacityTitle: {
        en: "Edit capacities",
        es: "Editar capacidades",
    },
    noCapacity: {
        en: "No capacity available.",
        es: "No hay capacidad.",
    },
    justTime: {
        en: "Consider vehicle capacity.",
        es: "Considerar capacidad del vehículo.",
    },
    serviceTime: {
        en: "Service time",
        es: "Tiempo de servicio",
    },
    selectRoutes: {
        en: "Select a route",
        es: "Selecciona una ruta",
    },
    order: {
        en: "Order",
        es: "Orden",
    },
    noRoutes: {
        en: "No routes.",
        es: "No hay rutas.",
    },
    routeIsRequired: {
        en: "Route is required.",
        es: "Una ruta es requerida.",
    },
    routePlannerReport: {
        en: "Route planner",
        es: "Planeador de rutas",
    },
};
exports.default = translations;
